import { render, staticRenderFns } from "./DataKota.vue?vue&type=template&id=ec70a1ea&scoped=true"
import script from "./DataKota.vue?vue&type=script&lang=js"
export * from "./DataKota.vue?vue&type=script&lang=js"
import style0 from "./DataKota.vue?vue&type=style&index=0&id=ec70a1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70a1ea",
  null
  
)

export default component.exports